import { render, staticRenderFns } from "./ContainerWidget.vue?vue&type=template&id=5f164f82&scoped=true"
import script from "./ContainerWidget.vue?vue&type=script&lang=js"
export * from "./ContainerWidget.vue?vue&type=script&lang=js"
import style0 from "./ContainerWidget.vue?vue&type=style&index=0&id=5f164f82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f164f82",
  null
  
)

export default component.exports